module.exports = __webpack_public_path__ + "static/MM-27641bdd7a37b83995c226824d562015.jpg";